import React, { ComponentType, ReactNode, useMemo } from 'react'
import classNames from 'classnames'
import {
  CustomDropdownItemOption,
  DropDownItemOptionComponentProps,
  SelectDropdown,
  SelectOption,
} from '../../../../../../../../components/SelectDropdown/SelectDropdown'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

export interface HeaderResultOption {
  className?: string
  selectOption: SelectOption
  icon?: string
  handleSelected: (option: SelectOption) => void | Promise<void>
  IconComponent?: ComponentType
  children?: ReactNode
  triggerOverlay?: boolean
  tooltipLabel?: string
}

export interface HeaderResultOptionsButtonProps {
  resultOptions: HeaderResultOption[]
  disabled: boolean
}

export const HeaderResultOptionsButton: React.FC<HeaderResultOptionsButtonProps> = ({ resultOptions, disabled }) => {
  const options = useMemo(() => resultOptions.map(({ selectOption }) => selectOption), [resultOptions])

  const handleOptionSelected = async (option: SelectOption) => {
    const { id: resultOptionId } = option
    const resultOption = resultOptions.find((resultOption) => resultOption.selectOption.id === resultOptionId)
    if (!resultOption) {
      return
    }
    const { handleSelected } = resultOption
    await handleSelected(option)
  }

  const HeaderResultDropdownItemOption: React.FC<DropDownItemOptionComponentProps> = ({ optionId, optionLabel, disabled, onClick }) => {
    const resultOption = resultOptions.find((resultOption) => resultOption.selectOption.id === optionId)
    if (!resultOption) {
      return null
    }
    const { icon, className, IconComponent, triggerOverlay, tooltipLabel } = resultOption

    return (
      <OverlayTrigger trigger={triggerOverlay ? ['hover', 'focus'] : []} overlay={<Tooltip id={`${optionId}-tooltip`}>{tooltipLabel}</Tooltip>}>
        <CustomDropdownItemOption
          role='button'
          onClick={!disabled ? onClick : undefined}
          className={classNames('d-flex gap-2 align-items-center', className, { 'dropdown-item-disabled': disabled })}
        >
          {IconComponent ? <IconComponent /> : icon ? <i className={`bi ${icon}`} /> : null}
          {optionLabel}
        </CustomDropdownItemOption>
      </OverlayTrigger>
    )
  }

  return (
    <div className='result-dropdown-container'>
      <SelectDropdown
        className='zocks-py-0.375 px-2'
        options={options}
        icon='bi-three-dots-vertical'
        iconOnly
        hideArrows
        onOptionSelected={handleOptionSelected}
        DropDownItemOptionComponent={HeaderResultDropdownItemOption}
        disabled={disabled}
      />
      {}
    </div>
  )
}
